/**
 * Opens share with a pre-filled message.
 * Uses the native share sheet when available, otherwise WhatsApp Web/App.
 */
export function openWhatsAppShare(message: string): void {
  const normalizedMessage = message.normalize("NFC");

  const openWhatsAppUrl = () => {
    const encodedText = encodeURIComponent(normalizedMessage);
    const url = `https://api.whatsapp.com/send?text=${encodedText}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (typeof navigator.share === "function") {
    const payload = { text: normalizedMessage };
    const canShare =
      typeof navigator.canShare !== "function" || navigator.canShare(payload);

    if (canShare) {
      navigator.share(payload).catch((error: unknown) => {
        if (error instanceof DOMException && error.name === "AbortError") return;
        openWhatsAppUrl();
      });
      return;
    }
  }

  openWhatsAppUrl();
}
